jQuery(document).ready(function ($) {
  $('.module-opener-level2 [data-style="trigger"]').click(function(e){
    e.preventDefault();

    $target = $(this).parent().prev();
    $target.slideToggle();

    $trigger = $(this);
    $trigger_label = $trigger.attr('data-label');
    $trigger_label_opened = $trigger.attr('data-label-opened');
    $trigger.toggleClass('is-open');
    toggleLabel($trigger, $trigger_label, $trigger_label_opened);
    if($parent){
      $parent.toggleClass('is-open');
    } 
  });

  var toggleLabel = function ($trigger, $trigger_label, $trigger_label_opened){
    if($($trigger).hasClass('is-open')){
      $($trigger).find('.label').text($trigger_label_opened);
    } else {
      $($trigger).find('.label').text($trigger_label);
    }
  };

});